import ShareService from "@/lib/ShareService";
import { toast } from "sonner";

// Backend preview URL: crawlers get an RGM-branded card, people land on /beams/{id}.
export const beamShareUrl = (roomId) => `${window.location.origin}/api/share/beam/${roomId}`;

export const shareBeam = async (room) => {
  const url = beamShareUrl(room.room_id);
  const audio = room.beam_kind === "audio";
  const text = `${audio ? "🎧" : "🎙"} ${room.title}${room.host_name ? ` with ${room.host_name}` : ""} on RGM Studio`;
  if (ShareService.canNativeShare()) {
    const res = await ShareService.share({ title: room.title, text, url });
    if (res === "shared" || res === "cancelled") return res;
  }
  const ok = await ShareService.copyLink(url);
  if (ok) toast.success("Live Beam link copied");
  else toast.error("Could not copy the link");
  return ok ? "copied" : "failed";
};
